<div class="no-results">
    <mat-icon color="primary" class="no-results__icon" aria-hidden="true">{{ icon }}</mat-icon>
    <p class="no-results__title">{{ label | translate }}</p>
    <p *ngIf="description" class="no-results__description">{{ description | translate }}</p>
</div>
